import type { ReactElement } from "react";
import { RealtimeStatusBanner } from "@compositions/index";
import { useConnectionState } from "../realtime/useConnectionState";

/**
 * Connects the "Live updates are off" banner to the realtime connection state.
 *
 * Only this component reads the state, so a state change re-renders the
 * banner and nothing below it. The hook comes from its own module, not from
 * the `../realtime` barrel, because tests mock that barrel.
 */
export function LiveUpdatesBanner({ gutter }: { readonly gutter?: string }): ReactElement {
  const state = useConnectionState();
  return <RealtimeStatusBanner state={state} {...(gutter !== undefined ? { gutter } : {})} />;
}
